'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('mark', {
    url: '/mark',
    template: '<mark></mark>'
  });
}



// WEBPACK FOOTER //
// ./client/app/mark/mark.routes.js